import { render, staticRenderFns } from "./LubangTanam.vue?vue&type=template&id=05d56a09"
import script from "./LubangTanam.vue?vue&type=script&lang=js"
export * from "./LubangTanam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports